export const dealerAndHoldingRoleChecker = (role: string): boolean => {
  return role === "dealer" || role === "holding";
};
